// frontend/packages/business-console/src/components/media/MediaToolbar.jsx

import React from "react";
import { Autocomplete, Box, Button, Chip, Stack, TextField, createFilterOptions } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

// Match suggestions anywhere in the string (substring) — the MUI default is
// startsWith, which would force users to type the exact prefix. Trimming and
// lowercasing both sides means "Exper" matches an "expertise" tag.
const substringFilter = createFilterOptions({
  matchFrom: "any",
  trim: true,
  ignoreCase: true,
});

export default function MediaToolbar({
  search,
  onSearch,
  folder,
  onFolder,
  folderOptions = [],
  tags,
  onTags,
  tagOptions = [],
  onRefresh,
}) {
  const tagValue = Array.isArray(tags) ? tags : [];

  return (
    <Box>
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={1.5}
        alignItems={{ md: "flex-start" }}
      >
        <TextField
          label="Search"
          value={search || ""}
          onChange={(e) => onSearch(e.target.value)}
          size="small"
          fullWidth
          sx={{ flex: { md: 2 } }}
        />

        <Autocomplete
          freeSolo
          size="small"
          options={folderOptions}
          filterOptions={substringFilter}
          value={folder || ""}
          onInputChange={(_e, value) => onFolder(value || "")}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Folder"
              placeholder="brand/, blog/, services/, team/"
            />
          )}
          sx={{ flex: { md: 1 }, minWidth: { md: 200 } }}
        />

        <Autocomplete
          multiple
          freeSolo
          size="small"
          options={tagOptions}
          filterOptions={substringFilter}
          value={tagValue}
          onChange={(_e, next) => onTags(next.map((t) => String(t).trim()).filter(Boolean))}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => {
              const { key, ...chipProps } = getTagProps({ index });
              return <Chip key={key} {...chipProps} label={option} size="small" />;
            })
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Tags"
              placeholder={tagValue.length ? "" : "Add tag..."}
            />
          )}
          sx={{ flex: { md: 1.5 }, minWidth: { md: 200 } }}
        />

        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          onClick={onRefresh}
          size="small"
          sx={{
            fontWeight: 700,
            whiteSpace: "nowrap",
            px: 2,
            height: 40,
            alignSelf: { md: "flex-start" },
          }}
        >
          Refresh
        </Button>
      </Stack>
    </Box>
  );
}
